import React from 'react';

import { Sm, Md } from '../screens.js'

function AppBar(props) {


    return (
        <>
            <Sm down>
                <div className="w-full z-40 shadow-md top-0 text-contrast-primary right-0 fixed bg-primary ">
                    {props.children}
                </div>
            </Sm>
            <Md up>
                <div style={{ width: `calc(100% - ${props.menuWidth}px)` }} className="w-full z-40 text-contrast-primary shadow-md top-0 right-0 fixed bg-primary ">
                    {props.children}
                </div>
            </Md>

            

        </>



    )

}

export default AppBar;